"use strict";
exports.__esModule = true;
exports.Paging = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
function getbuttonIcoStyle(type, buttonsOrientation) {
    if (type === "prev") {
        if (buttonsOrientation === "upDown") {
            return "up";
        }
        return "left";
    }
    if (type === "next") {
        if (buttonsOrientation === "upDown") {
            return "down";
        }
        return "right";
    }
    return undefined;
}
function renderPagingButton(type, buttonsOrientation, handler, disabled) {
    var classes = classnames_1["default"]("gd-button-link", "gd-button-icon-only", "gd-icon-chevron-" + getbuttonIcoStyle(type, buttonsOrientation), "paging-button");
    var onClick = function (e) {
        e.stopPropagation();
        handler();
    };
    return react_1["default"].createElement("button", { className: classes, onClick: onClick, disabled: disabled });
}
/**
 * @internal
 */
exports.Paging = function (props) {
    var page = props.page, pagesCount = props.pagesCount, _a = props.buttonsOrientation, buttonsOrientation = _a === void 0 ? "upDown" : _a, showNextPage = props.showNextPage, showPrevPage = props.showPrevPage;
    return (react_1["default"].createElement("div", { className: "paging" },
        renderPagingButton("prev", buttonsOrientation, showPrevPage, page === 1),
        react_1["default"].createElement(react_intl_1.FormattedMessage, { id: "visualizations.of", tagName: "span", values: {
                page: react_1["default"].createElement("strong", null, page),
                pagesCount: pagesCount
            } }),
        renderPagingButton("next", buttonsOrientation, showNextPage, page === pagesCount)));
};
//# sourceMappingURL=Paging.js.map